module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9557_clementine.199d15c7.jpg";